import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from '@mui/material';

import { SubmitButton } from 'src/presentations/components/atom/button/SubmitButton';
import SendIcon from 'src/assets/images/icons/send.svg';

import { DisputeStep, IDisputeFormValues } from './types';
import { DisputeContext } from './DisputeContext';

export const DisputeFooter = () => {
  const formContext = useFormContext<IDisputeFormValues>();
  const formValues = formContext.watch();
  const { agreementType } = formValues;
  const { activeStep, setActiveStep, onSaveDraft, onClose, onReject, onSend, onSuccessSubmit, isDisableSave } = useContext(DisputeContext);

  return (
    <div className='mt-auto px-24 py-20 border-t border-neutral-20 flex items-center'>
      {activeStep > DisputeStep.Step1_ContactServiceProvider && (
        <Button type='button' variant='outlined' color='inherit' onClick={() => setActiveStep(activeStep - 1)} sx={{ textTransform: 'capitalize' }}>
          Back
        </Button>
      )}
      <div className='ml-auto pl-12 flex items-center gap-16'>
        {activeStep === DisputeStep.Step1_ContactServiceProvider && (
          <Button type='button' variant='outlined' color='inherit' onClick={onClose} sx={{ textTransform: 'capitalize' }}>
            Close
          </Button>
        )}
        {activeStep === DisputeStep.Step2_Resolution && (
          <>
            <SubmitButton
              variant='outlined'
              color='inherit'
              onClick={formContext.handleSubmit(onSaveDraft)}
              sx={(theme) => ({
                ':disabled': {
                  color: theme.palette.common.black,
                  background: theme.palette.background.default,
                },
                textTransform: 'capitalize',
              })}
              disabled={isDisableSave}
            >
              Save Draft & Close
            </SubmitButton>
            <SubmitButton
              variant='contained'
              color='primary'
              onClick={formContext.handleSubmit(onSuccessSubmit)}
              sx={{ textTransform: 'capitalize' }}
              disabled={isDisableSave}
            >
              Next Step
            </SubmitButton>
          </>
        )}
        {activeStep === DisputeStep.Step3_Summary && (
          <>
            <SubmitButton
              variant='outlined'
              color='inherit'
              onClick={formContext.handleSubmit(onSaveDraft)}
              sx={(theme) => ({
                ':disabled': {
                  color: theme.palette.common.black,
                  background: theme.palette.background.default,
                },
                textTransform: 'capitalize',
              })}
              disabled={isDisableSave}
            >
              Save Draft & Close
            </SubmitButton>
            {agreementType === 'ACCEPT_INVOICE_WITH_CREDIT_NOTE' && (
              <SubmitButton
                variant='contained'
                color='primary'
                onClick={formContext.handleSubmit(onSend)}
                endIcon={<img src={SendIcon} alt='Send Icon' />}
                sx={{ textTransform: 'capitalize' }}
                disabled={isDisableSave}
              >
                Ready for Payment
              </SubmitButton>
            )}
            {agreementType === 'REJECT_INVOICE' && (
              <SubmitButton
                variant='contained'
                color='error'
                onClick={formContext.handleSubmit(onReject)}
                sx={{ textTransform: 'capitalize' }}
                disabled={isDisableSave}
              >
                Reject Invoice
              </SubmitButton>
            )}
            {(agreementType === 'CANCEL_DISPUTE' || agreementType === null) && (
              <SubmitButton
                variant='contained'
                color='primary'
                onClick={formContext.handleSubmit(onReject)}
                sx={{ textTransform: 'capitalize' }}
                disabled={isDisableSave}
              >
                Cancel Dispute
              </SubmitButton>
            )}
          </>
        )}
      </div>
    </div>
  );
};
